// extracted by mini-css-extract-plugin
export default {"input":"hE2Xr___RadioInput-module__input","label":"qTixT___RadioInput-module__label"};